# WHICH MENU, AND WHAT IS ON IT — card 6ac022cba664bc34d57be8c9 (owner
# 2026-10-03).
#
# The server hands the page every Menu document (common/menus.coffee) as
# window.menus. A document is one whole menu for one key — an account type and,
# optionally, an app — and it REPLACES the built-in menu, in order. The menu
# code picks the key: the classic drawer asks for (account type), the mobile
# Shell row for (account type, 'mobile'), which falls back to (account type).
#
#   {builtin: 'manageAccount'}                    a built-in entry. Its RULES stay
#                                                 in code (who may see it, on which
#                                                 device); the document only places
#                                                 it. A label overrides its text.
#   {route: 'ReadingCorner', label: 'Reading…'}   a screen: the Screens App's, or
#                                                 any built-in route.
#
# Guards: no document for the key is the built-in menu exactly as the code
# builds it; an entry naming a route or a built-in that does not exist is
# skipped and logged, never shown dead; and the ESCAPE HATCHES are always
# there — Log Out, and the switch between the two views (New Mobile View in a
# Classic View phone's drawer, Classic View in the mobile menu) — appended if a
# document leaves them out, so no edit can trap anyone.
#
# IMPORT-FREE ON PURPOSE: a pin drives it with plain objects.

export REQUIRED = ['mobileView', 'classicView', 'logOut']

# The account's key. A child's session is 'student' whatever account it is in;
# an account with no type is a parent's (that is how parents are stored).
export accountKey = (app) ->
  return 'student' if app?.isStudentLock?()
  type = app?.account?.type
  if type? and String(type).trim() then String(type).trim().toLowerCase() else 'parent'

# The Menu document for a key, or null. An app's own document replaces the
# general one; with none, the general one serves.
export chooseMenu = (menus, key, app = null) ->
  rows = (m for m in (menus ? []) when m?.accountType is key)
  if app?
    own = (m for m in rows when m.app is app)[0]
    return own if own?
  (m for m in rows when not m.app)[0] ? null

# The entries to show, in order. builtins: the built-in entries the CODE allows
# here, in the code's order, each {name, …}. routeExists(name) -> boolean. With
# no document, the built-ins as they are.
#   -> [{builtin: <the builtins entry>, label?} | {route, label}]
export resolveMenu = (doc, builtins, routeExists, log = (->)) ->
  byName = {}
  byName[b.name] = b for b in builtins
  return ({builtin: b} for b in builtins) unless doc?
  out = []
  placed = {}
  for item in doc.items ? []
    if item?.builtin?
      b = byName[item.builtin]
      unless b?
        # Not allowed here (the code's rules), or not a built-in at all. Only the
        # second is a mistake in the document.
        log "menu #{doc.accountType}#{if doc.app then '/' + doc.app else ''}: no built-in entry '#{item.builtin}'" unless item.builtin in KNOWN
        continue
      continue if placed[b.name]
      placed[b.name] = true
      out.push if item.label then {builtin: b, label: String(item.label)} else {builtin: b}
    else if item?.route?
      route = String(item.route)
      unless routeExists(route)
        log "menu #{doc.accountType}#{if doc.app then '/' + doc.app else ''}: no route '#{route}' — skipped"
        continue
      out.push {route, label: String(item.label ? route)}
  # Missing escape hatches go just above Log Out (or at the end, Log Out last).
  missing = ({builtin: byName[name]} for name in REQUIRED when byName[name]? and not placed[name] and name isnt 'logOut')
  at = (i for e, i in out when e.builtin?.name is 'logOut')[0] ? out.length
  out.splice at, 0, missing...
  out.push {builtin: byName.logOut} if byName.logOut? and not placed.logOut
  out

# Every built-in entry a document may name (any menu). Naming one the code does
# not allow HERE is not a mistake: it is simply not shown.
export KNOWN = [
  'dashboard', 'manageAccount', 'manageSubscription', 'worksheet', 'anxietyCoaching',
  'qrLogins', 'placementReport', 'progressReport', 'teacherSharing', 'mobileView',
  'classicView', 'about', 'help', 'darkMode', 'logOut'
]
